import axios from 'axios'

const getDefaultState = () => {
    return {
        table: {
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: '',
                    type: '',
                },
                q: '',
                page: 1,
                perPage: 10
            }
        }
    }
}

// initial state
const state = getDefaultState()

const mutations = {
    'TABLE_RESET'(state) {
        Object.assign(state, getDefaultState())
    },
    'FETCH_ITEMS'(state, data) {
        state.table.rows = data.data
        state.table.totalRecords = data.meta.total
        state.table.serverParams.page = data.meta.current_page
        state.table.serverParams.perPage = data.meta.per_page
    },
    'CHANGE_SERVERPARAMS'(state, data) {
        state.table.serverParams = Object.assign({}, state.table.serverParams, data);
    }
}

const actions = {
    CALL_CHART_MODAL_SERVERDATA: async ({commit, state, rootState}) => {
        return axios.post(process.env.VUE_APP_API_URL + 'items/list', {
            countries: rootState.chart.form.countries,
            sources: rootState.chart.form.sources,
            contact : (rootState.chart.form.contacts.id) ? rootState.chart.form.contacts.id : '',
            start_date: (rootState.chart.form.date) ? rootState.chart.form.date.start : '',
            end_date: (rootState.chart.form.date) ? rootState.chart.form.date.end : '',
            sales_modular: rootState.chart.form.sales_modular,
            chart: rootState.chart.form.chart,
            chart_item: rootState.chart.form.chart_item,
            page: state.table.serverParams.page,
            perPage: state.table.serverParams.perPage,
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    CHANGE_SERVERPARAMS: async (context, payload) => {
        context.commit('CHANGE_SERVERPARAMS', payload)
    },
}

const getters = {
    TABLE: state => {
        return state.table;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
